import { Button, ExternalStyles, Theme, useStyles } from 'bold-ui'
import { css } from 'emotion'
import { useHistory } from 'react-router'

import { SubmitButton } from './final-form/SubmitButton'

interface FormFooterProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'style'> {
  style?: ExternalStyles
}

export const FormFooter = ({ style, ...props }: FormFooterProps) => {
  const { classes } = useStyles(createStyles)

  return (
    <div className={css(classes.container, style)} {...props}>
      {props.children}
    </div>
  )
}

export interface DefaultFormFooterProps {
  onCancel?(): void
  handleSubmit(event?: React.SyntheticEvent<HTMLFormElement>): void
  loading?: boolean
  throttleSubmit?: boolean
  buttonsId?: string
}

export function DefaultFormFooter(props: DefaultFormFooterProps) {
  const history = useHistory()

  const buttons = (
    <>
      <Button onClick={props.onCancel || history.goBack} data-cy='FormFooter.cancelar'>
        Cancelar
      </Button>
      <SubmitButton
        handleSubmit={props.handleSubmit}
        data-cy='FormFooter.salvar'
        loading={props.loading}
        throttleSubmit={props.throttleSubmit}
      >
        Salvar
      </SubmitButton>
    </>
  )

  return (
    <FormFooter>
      {props.buttonsId ? (
        <span id={props.buttonsId} style={{ display: 'inline-flex', gap: '1rem' }}>
          {buttons}
        </span>
      ) : (
        buttons
      )}
    </FormFooter>
  )
}

const createStyles = (theme: Theme) => ({
  container: {
    borderTop: `1px solid ${theme.pallete.divider}`,
    padding: '1rem 0',
    margin: '2rem 0',
    textAlign: 'right',
    '& > *:not(:last-child)': {
      marginRight: '1rem',
    },
  } as React.CSSProperties,
})
